import React from 'react';

export default function User({ name, session_room_id }) {
  return (
    <a
      href={`/chats/${session_room_id}/show_admin`}
      className="session-room-show-student-info"
      title="Click to check LeggUP Lab details for these users"
      data-toggle="tooltip"
      data-method="post"
      data-type="html"
      data-remote="true"
    >
      {name}
    </a>
  );
}
